import { render, staticRenderFns } from "./PersonAddress.vue?vue&type=template&id=66664d2d&"
import script from "./PersonAddress.vue?vue&type=script&lang=js&"
export * from "./PersonAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports